"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEventPropertiesSchema = exports.getEventPropertiesSchema = exports.setEventSchema = exports.getEventSchema = void 0;
const DOMAIN_EVENT_SYM = Symbol.for("@leavy/domain-events/DOMAIN_EVENT_META");
const DOMAIN_EVENT_PROPS_SYM = Symbol.for("@leavy/domain-events/DOMAIN_EVENT_PROPERTIES_META");
/**
 * Extract the event schema from the given class
 * @param eventClass A domain event class that should have been decorated with the {@link DomainEvent} decorator
 */
function getEventSchema(eventClass) {
    let schema = eventClass[DOMAIN_EVENT_SYM];
    // true when the schema is inherited
    if (schema && !eventClass.hasOwnProperty(DOMAIN_EVENT_SYM)) {
        schema = {
            eventName: schema.eventName,
            version: schema.version,
            namespace: schema.namespace,
            properties: [...schema.properties],
        };
        setEventSchema(eventClass, schema);
    }
    return schema !== null && schema !== void 0 ? schema : null;
}
exports.getEventSchema = getEventSchema;
/**
 * Attach the given {@link EventSchema} on the target Domain Event class
 * @param target A domain event class
 * @param schema The event schema
 */
function setEventSchema(target, schema) {
    target[DOMAIN_EVENT_SYM] = schema;
}
exports.setEventSchema = setEventSchema;
/**
 * Extract the event properties schema from the given class
 * @param eventClass
 */
function getEventPropertiesSchema(eventClass) {
    let properties = eventClass[DOMAIN_EVENT_PROPS_SYM];
    // true when the schema is inherited
    if (properties && !eventClass.hasOwnProperty(DOMAIN_EVENT_PROPS_SYM)) {
        properties = [...properties];
        setEventPropertiesSchema(eventClass, properties);
    }
    return properties !== null && properties !== void 0 ? properties : null;
}
exports.getEventPropertiesSchema = getEventPropertiesSchema;
/**
 * Attach the given property schemas on the target Domain Event class
 * @param target A domain event class
 * @param properties The properties schemas
 */
function setEventPropertiesSchema(target, properties) {
    target[DOMAIN_EVENT_PROPS_SYM] = properties;
}
exports.setEventPropertiesSchema = setEventPropertiesSchema;
//# sourceMappingURL=EventSchema.js.map